import axios from 'axios';
import cache, { getCacheKey } from './cache';
import ls, { USER_NOR_GET_SHI_SHI } from './utils/ls';

const DEFAULT_API_URL = "https://api.fixouresources.org/api/v1";
const apiBaseUrl = process.env.REACT_APP_BUDGIT_URL || process.env.REACT_APP_DEV_URL || DEFAULT_API_URL;

const instance = axios.create({
    baseURL: apiBaseUrl
});

instance.interceptors.request.use(function (request) {
    const { method, url, params = {} } = request;
    if((method === 'get' || method === 'GET') && !params?.noCache) {
      const cacheKey = getCacheKey({
        url,
        ...params
      });
      const data = cache.get(cacheKey);
      if(data) {
        request.headers.cached = true;
        request.data = data;
        return Promise.reject(request)
      }
      return request
    }
    return request;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });


  instance.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      const { config } = response;
      if (config.method === "GET" || config.method === "get") {
        const { url, params } = config;
        const cacheKey = getCacheKey({
          url,
          ...params,
        });
        cache.set(cacheKey, response?.data);
      }
      if (["post", "put", "delete"].includes(config.method.toLowerCase())) {
        cache.reset();
      }
      return response;
    },
    function (error) {

      if(error?.response?.status === 401) {
        ls.delete(USER_NOR_GET_SHI_SHI)
        window.location.reload()
      }
      if (error?.headers?.cached) {
        return Promise.resolve(error);
      }
      return Promise.reject(error);
    }
  );


const createApiService = ({ endpoint, method, options = {} }) => {
  const requestOptions = {
    ...options,
    baseURL: options.baseURL || apiBaseUrl,
  };

  switch (method) {
    case "post":
      return (params) => instance.post(endpoint, params, requestOptions);
    case "put":
      return (params) => instance.put(endpoint, params, requestOptions);
    case "delete":
      return () => instance.delete(endpoint, requestOptions);

    default:
      return () => instance.get(endpoint, requestOptions);
  }
};

export default createApiService;
